export class WebPreloader {
    public static enable() {
        const $webPreloader = $('.web-loader');
        $webPreloader.css('visibility', 'visible');
        $webPreloader.css('z-index', '1');
    }

    public static disable() {
        const $webPreloader = $('.web-loader');
        $webPreloader.css('visibility', 'hidden');
        $webPreloader.css('z-index', '0');
    }
}
